import type { IRecordTypeDefinition } from '@platform/core/types';

/**
 * Поля ключового рядка (UIUX forms/key-line, прототип v4): поля `form.keyLine` визначення, що є в типі запису; виконавець (поле
 * `assignee`) — першим, якщо тип його має, а визначення не розмістило його в ключовому рядку саме (прототип показує «ВИКОНАВЕЦЬ:»
 * перед «СТАТУС · ПРІОРИТЕТ · ТЕРМІН»). Чиста функція.
 */
export function keyLineKeys(rt: Pick<IRecordTypeDefinition, 'fields' | 'form'>): string[] {
  const known = new Set(rt.fields.map((f) => f.key));
  const own = rt.form.keyLine.filter((k, i, all) => known.has(k) && all.indexOf(k) === i);
  const assignee = rt.fields.some((f) => f.key === 'assignee' && f.type === 'user') && !own.includes('assignee');
  return assignee ? ['assignee', ...own] : own;
}
